import axios from "axios";

// Clinic-level (no branchUrl) master treatments / medicine & products / labs,
// managed by PROCUREMENT. `kind` is "treat", "item" or "lab"; the BE overwrites the
// stock-product links of a treatment / item on every branch of the clinic.
const base = (kind, clinicUrl) => `/api/master/clinic/${kind}/${clinicUrl}`;

// The modals read categories / doctors from the shared stores the branch pages
// use, so the clinic-level lists are committed there.
const CATE_MUTATION = {
  treat: "moduleAppointment/setTreatCateList",
  item: "moduleAppointment/setItemCateList",
};

// DF section: a treatment lists the clinic's doctors, an item every branch user
// (the same split the branch pages make).
const PEOPLE = {
  treat: { roleIds: "2", mutation: "moduleUser/setDoctorList" },
  item: { roleIds: "1,2,3,4,5,6,7", mutation: "moduleUser/setUserList" },
};

// Shape of the product picker the modals expect (see productInventory store).
export const toModalProduct = p => ({
  productId: p.id,
  productCode: p.no,
  productNameMain: p.description,
  productNameAdditional: p.description2,
  productUnit: p.baseUom,
  productStatus: p.status,
  imageUrl: null,
});

const moduleClinicMaster = {
  namespaced: true,
  actions: {
    fetchOne(_, { kind, clinicUrl, id }) {
      return axios.get(`${base(kind, clinicUrl)}/${id}`);
    },
    create(_, { kind, clinicUrl, event }) {
      return axios.post(base(kind, clinicUrl), event);
    },
    update(_, { kind, clinicUrl, event }) {
      const { id, branchId, clinicId, del, creationDt, ...body } = event;
      return axios.put(`${base(kind, clinicUrl)}/${id}`, body);
    },
    remove(_, { kind, clinicUrl, id }) {
      return axios.delete(`${base(kind, clinicUrl)}/${id}`);
    },

    // Categories, the people the DF section lists and the stock products for the
    // modal. Returns the product picker list; the rest goes to the shared stores.
    async fetchFormOptions({ commit }, { kind, clinicUrl }) {
      // a lab only needs the lab companies for its dropdown
      if (kind === "lab") {
        const companies = await axios.get(`/api/master/clinic/labCompanies/${clinicUrl}`);
        commit("moduleLab/setLabCompanyList", companies.data, { root: true });
        return [];
      }
      const [cates, people, products] = await Promise.all([
        axios.get(`/api/master/clinic/${kind}Cate/${clinicUrl}`),
        axios.get(`/api/master/clinic/doctors/${clinicUrl}`, {
          params: { roleIds: PEOPLE[kind].roleIds },
        }),
        axios.get(`/api/master/clinic/products/${clinicUrl}`),
      ]);
      commit(CATE_MUTATION[kind], cates.data, { root: true });
      commit(PEOPLE[kind].mutation, people.data, { root: true });
      return (products.data.data || []).map(toModalProduct);
    },
  },
};

export default moduleClinicMaster;
